import { useQuery } from '@tanstack/react-query';

import { gatewayApiAgent } from 'common/api/apiAgents';
import { CatalogUiLocalizedBrand } from 'common/api-types/catalog';
import { CountryCode } from 'common/api-types/common';

const BRANDS_QUERY_KEY_ROOT = 'brands';

type FetchBrandsParams = {
  languageCode: string;
  countriesWithActiveProducts?: CountryCode[];
  query?: string;
};

const fetchBrands = async (params: FetchBrandsParams) => {
  const { languageCode, countriesWithActiveProducts, query } = params;
  const res = await gatewayApiAgent.get<CatalogUiLocalizedBrand[]>(
    `/catalog/public/catalog-ui/v1/brands/languages/${languageCode}`,
    { params: { countriesWithActiveProducts, query } },
  );

  return res.data;
};

export const useBrandsQuery = (params: FetchBrandsParams, enabled?: boolean) => {
  return useQuery({
    queryKey: [BRANDS_QUERY_KEY_ROOT, params],
    queryFn: () => fetchBrands(params),
    staleTime: Infinity,
    enabled,
  });
};
